// GET_CURRENCY
export const GET_CONTENT = "GET_CONTENT";
export const GET_CONTENT_FAIL = "GET_CONTENT_FAIL";
export const GET_CONTENT_SUCCESS = "GET_CONTENT_SUCCESS";

